import { useState } from "react";

import { useLocalStorage } from "neetocommons/react-utils";
import { useErrorDisplayStore } from "neetocommons/react-utils/useDisplayErrorPage";
import { EditorContent } from "neetoeditor";
import { Button, Tag } from "neetoui";
import { pluck } from "ramda";
import { Trans } from "react-i18next";

import {
  STICKY_RIBBON_KIND_TO_STYLE,
  STICKY_RIBBONS_LOCAL_STORAGE_KEY,
} from "./constants";
import "./sticky-ribbons.scss";
import { useFetchStickyRibbons } from "./useStickyRibbonsApi";
import { formatMessageContent } from "./utils";

const StickyRibbonsContainer = () => {
  const [isRefreshRibbonDismissed, setIsRefreshRibbonDismissed] =
    useState(false);

  const [dismissedRibbons, setDismissedRibbons] = useLocalStorage(
    STICKY_RIBBONS_LOCAL_STORAGE_KEY,
    []
  );

  const { showRefreshRibbon } = useErrorDisplayStore.pick();

  const { data: { stickyRibbons = [] } = {} } = useFetchStickyRibbons();

  const handleDismiss = ribbonId => {
    const validRibbonIds = pluck("id", stickyRibbons);
    const updatedDismissedRibbons = dismissedRibbons.filter(id =>
      validRibbonIds.includes(id)
    );

    setDismissedRibbons([...updatedDismissedRibbons, ribbonId]);
  };

  const visibleRibbons = stickyRibbons.filter(
    ribbon => !dismissedRibbons.includes(ribbon.id)
  );

  return (
    <>
      {showRefreshRibbon && !isRefreshRibbonDismissed && (
        <Tag
          className="neeto-molecules-sticky-ribbon w-full p-2.5 text-center"
          data-testid="refresh-sticky-ribbon"
          size="large"
          style={STICKY_RIBBON_KIND_TO_STYLE["error"]}
          onClose={() => setIsRefreshRibbonDismissed(true)}
        >
          <span className="w-full">
            <Trans
              i18nKey="neetoMolecules.stickyRibbonsContainer.refreshRibbon"
              components={{
                button: (
                  <Button
                    data-testid="refresh-button"
                    style="link"
                    onClick={() => window.location.reload()}
                  />
                ),
              }}
            />
          </span>
        </Tag>
      )}
      {visibleRibbons.map(({ id, kind, message, startsAt, endsAt }) => (
        <Tag
          className="neeto-molecules-sticky-ribbon w-full p-2.5 text-center"
          data-testid="sticky-ribbon"
          key={id}
          size="large"
          style={STICKY_RIBBON_KIND_TO_STYLE[kind]}
          onClose={() => handleDismiss(id)}
        >
          <EditorContent
            className="w-full"
            content={formatMessageContent({ message, startsAt, endsAt })}
          />
        </Tag>
      ))}
    </>
  );
};

export default StickyRibbonsContainer;
